import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import { SalarieCompetenceDto } from "../../../../../dto/GenApi.iNotPaie.Dto/SalarieCompetenceDto";
import $ from "jquery";
import { LangueDto } from "../../../../../dto/GenApi.iNotPaie.Dto/LangueDto";

@Component
export default class ModalAjouterLangue extends Vue {
	@Prop()
	public salarie?: SalarieCompetenceDto = undefined;

	public estAjout = false;
	public langue?: LangueDto = undefined;

	public nom?: string = "";
	public lu?: string = "";
	public parler?: string = "";
	public juridique?: string = "";

	public onLangueChange(): void {
    	if (this.langue == undefined) {
			return;
		}

    	this.nom = this.langue.Nom;
    	this.lu = this.langue.Lu;
    	this.parler = this.langue.Parler;
    	this.juridique = this.langue.Juridique;
	}

	public initialize(langue: LangueDto, estAjout: boolean, salarie?: SalarieCompetenceDto): void {
    	this.salarie = salarie;
    	this.estAjout = estAjout;
    	this.langue = langue;

    	this.onLangueChange();
	}

	public enregistrer(): void {
    	if (this.salarie == undefined || this.langue == undefined || this.nom == undefined || this.nom == "") {
			return;
		}

    	this.langue.Nom = this.nom;
    	this.langue.Lu = this.lu;
    	this.langue.Parler = this.parler;
    	this.langue.Juridique = this.juridique;

    	this.$emit(this.estAjout ? "ajout" : "update", { langue: this.langue });
    	$("#modalAjouterLangue").modal("hide");
	}

	public annuler(): void {
    	$("#modalAjouterLangue").modal("hide");
	}
}



// WEBPACK FOOTER //
// ./src/components/ficheSalarie/competences/modals/ajouterLangue/ajouterLangue.ts